import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Link from 'Components/Link';

import {
  enableFormReconciliationMode,
  clearFormMessage,
  updateMultipageFormValues,
} from 'Store/forms/actions';
import {
  removePrefixFromFields,
  fieldsWithValuesOnly,
} from 'Store/forms/helpers';
import { checkUsernameValidity } from '../../api';

import FormNote from 'Components/FormNote';
import Form from 'Components/Form';
import { ROUTES } from 'Settings/route-strings';

class UsernameCheckForm extends React.PureComponent {
  state = {
    isPosting: false,
  };

  handleSubmit = (fields, isFormValid) => {
    this.props.clearFormMessage('paymentUsername', 'paymentUsername');
    if (!isFormValid) {
      this.props.enableFormReconciliationMode(
        'paymentUsername',
        'paymentUsername'
      );
      return;
    }
    this.setState({ isPosting: true });
    const fieldsWithoutPrefix = removePrefixFromFields(
      fields,
      'paymentUsername'
    );
    checkUsernameValidity(fieldsWithoutPrefix)
      .then(result => {
        this.setState({ isPosting: false });
        if (result.meta.status >= 400 && result.errorCode !== 49)
          throw new Error(result);
        const fieldValues = fieldsWithValuesOnly(fieldsWithoutPrefix);
        this.props.updateMultipageFormValues('loggedOutPayment', fieldValues);
        if (result.meta.status === 200) {
          console.log('on to setup!');
          this.props.history.push(ROUTES.SUBSCRIPTION_CREATE_ACCOUNT);
        }
        if (result.meta.status === 422 && result.errorCode === 49)
          this.props.history.push(ROUTES.SUBSCRIPTION_LOGIN);
        return result;
      })
      .catch(() => {
        console.log('we caught');
        this.setState({ isPosting: false });
      });
  };

  render() {
    return (
      <Form
        type="paymentUsername"
        id="paymentUsername"
        isReadOnly={this.state.isPosting}
        isPosting={this.state.isPosting}
        formStyle="login"
        formNote={
          <FormNote
            title="Note"
            text={
              <React.Fragment>
                If you already have an account, please{' '}
                <Link to={ROUTES.SIGN_IN} className="u-text-link">
                  sign in
                </Link>
                .
              </React.Fragment>
            }
          />
        }
        messagePosition="page-top"
        submitButtonType="primary"
        submitHandler={this.handleSubmit}
      />
    );
  }
}

UsernameCheckForm.propTypes = {
  enableFormReconciliationMode: PropTypes.func.isRequired,
  clearFormMessage: PropTypes.func.isRequired,
  updateMultipageFormValues: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
};

export default withRouter(
  connect(false, {
    enableFormReconciliationMode,
    clearFormMessage,
    updateMultipageFormValues,
  })(UsernameCheckForm)
);
